import api from './api';
import { CUISINE } from './endpoints';

const get = () => api.get(`${CUISINE}/`);

export default {
  get,
};
